export const timeOutOptions = (): {
  value: string | number;
  label: string;
}[] => {
  return [...Array(31)].map((_, i) => ({
    value: i + 15,
    label: `${i + 15} seconds`,
  }));
};
